import React from 'react';

const Footer = () => {
    return (
        <div className='text-center mb-1'>
            <small>&copy; All rights reserved.</small>
        </div>
    );
};

export default Footer;